<template>
  <div class="aftersale-person-dialog">
    <custom-dialog :title="model.title" :visible="visible" v-on="$listeners" width="500px">
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="form" ref="form" label-width="150px">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('asm_aftersale_person_dialog.shgcs')" prop="technicianType" :rules="rules.technicianType" style="width: 100%">
                <custom-select
                  v-model="form.technicianType"
                  :listener="`${orgId}`"
                  url="userAreaSelectList"
                  :props="{ label: 'userName', value: 'userId', map: { userName: 'technicianName', mobile: 'technicianPhone' } }"
                  :params="{ orgId: orgId }"
                  width="100%"
                  :model="form1"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('asm_aftersale_person_dialog.shou_hou_zhu_guan')">
                <custom-select
                  v-model="form.technicianType2"
                  :listener="`${orgId}`"
                  url="userAreaSelectList"
                  :props="{ label: 'userName', value: 'userId', map: { userName: 'technicianName', mobile: 'technicianPhone' } }"
                  :params="{ orgId: orgId }"
                  width="100%"
                  :model="form2"
                ></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      item: {},
      visible: false,
      organTree: [],
      form: {
        technicianType: '',
        technicianType2: '',
      },
      form1: {
        technicianName: '',
        technicianPhone: '',
      },
      form2: {
        technicianName: '',
        technicianPhone: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        technicianType: [
          {
            required: true,
            message: this.$t('asm_aftersale_person_dialog.qxzshfzr'),
          },
        ],
      };
    },
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
  },
  mounted() {
    this.initDialog();
    this.getOrganTree();
    this.initRule();
  },
  methods: {
    // 获取组织
    getOrganTree: function () {
      this.$getJSON(apis.OrganTree, { isShowUsers: 1 }).then((res) => {
        this.organTree = res.data[0] ? res.data[0].children : [];
      });
    },
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.model.type === 'edit') {
        this.item = this.model.data;
        this.form.technicianType = this.item.length === 1 ? this.item[0].technicianId1 || '' : '';
        this.form.technicianType2 = this.item.length === 1 ? this.item[0].technicianId2 || '' : '';
        this.form1.technicianName = this.item.length === 1 ? this.item[0].technicianName1 || '' : '';
        this.form1.technicianPhone = this.item.length === 1 ? this.item[0].technicianPhone1 || '' : '';
        this.form2.technicianName = this.item.length === 1 ? this.item[0].technicianName2 || '' : '';
        this.form2.technicianPhone = this.item.length === 1 ? this.item[0].technicianPhone2 || '' : '';
      }
      if (this.model.type === 'wait_workorder') {
        this.item = this.model.data.item;
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.form.technicianType === this.form.technicianType2) {
          // 第一 第二负责人重复
          this.$message.error(this.$t('asm_aftersale_person_dialog.shgcsyshzgbnxzcf'));
          return;
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
        if (this.model.type === 'wait_workorder') {
          this.saveWaitUpdate();
        }
      });
    },
    // 保存编辑
    saveUpdate: function () {
      const list = [
        {
          technicianId: this.form.technicianType,
          technicianName: this.form1.technicianName,
          technicianPhone: this.form1.technicianPhone,
          technicianType: 1,
        },
      ];
      if (this.form.technicianType2) {
        list.push({
          technicianId: this.form.technicianType2,
          technicianName: this.form2.technicianName,
          technicianPhone: this.form2.technicianPhone,
          technicianType: 2,
        });
      }
      this.$postJSON(apis.TechnicianBatchSave, {
        deviceList: this.item.map(t => ({ afterServiceId: t.afterServiceId, afterServiceName: t.afterServiceName, bodyNum: t.bodyNum, deviceId: t.deviceId, productCode: t.productCode })),
        technicianList: list.filter(i => !!i.technicianId),
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_save_success'),
          type: 'success',
        });
        this.closeDialog();
        this.$emit('success', this.form);
      });
    },
    // 保存编辑(待分配工单)
    saveWaitUpdate: function () {
      const list = [
        {
          afterServiceId: this.item.afterServiceId,
          afterServiceName: this.item.afterServiceName,
          bodyNum: this.item.bodyNum,
          deviceId: this.item.deviceId,
          productCode: this.item.productCode,
          technicianId: this.form.technicianType,
          technicianType: 1,
        },
        {
          afterServiceId: this.item.afterServiceId,
          afterServiceName: this.item.afterServiceName,
          bodyNum: this.item.bodyNum,
          deviceId: this.item.deviceId,
          productCode: this.item.productCode,
          technicianId: this.form.technicianType2,
          technicianType: 2,
        },
      ];
      this.$postJSON(
        `${apis.WorkOrderWaitPerson}/${this.item.workOrderId}`,
        list.filter(i => !!i.technicianId)
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_save_success'),
          type: 'success',
        });
        this.closeDialog();
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss"></style>
